import React, { useState, useEffect } from "react";
import MasterTable from "../common/MasterTable";
import RoleModal from "../role/RoleModal";
import RoleFilterModal from "../role/RoleFilterModal";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import HeaderWithBreadcrumb from "../common/HeaderWithBreadcrumb";
import FilterBar from "../common/FilterBar";
import { asStatusList } from "../common/filterOptions";

const ROLE_STATUS_OPTIONS = [
  { value: "Active", label: "Active" },
  { value: "In-Active", label: "In-Active" },
  { value: "Block", label: "Blocked" },
];

const ROLE_PROFILE_OPTIONS = [
  { value: "OPERATION", label: "Operation" },
  { value: "CUSTOMER", label: "LMBP" },
  { value: "SUB_LMBP", label: "Sub-LMBP" },
  { value: "FRANCHISE", label: "Franchise" },
  { value: "HUB", label: "Hub" },
];

const defaultFilterData = {
  userProfile: null,
  roleName: "",
  status: [],
  fromDate: "",
  toDate: "",
  search: "",
};

const RoleMaster = () => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [roleData, setRoleData] = useState([]);
  const [modalAction, setModalAction] = useState("");
  const [pageDetails, setPageDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);

  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  const handleReset = () => {
    setFilterData(defaultFilterData);
    // fetchRoleData(1, defaultFilterData);
    setCurrentPage(1);
    fetchRoleData(1, defaultFilterData, pageSize);
  };

  useEffect(() => {
    fetchRoleData(1, filterData);
  }, []);

  const fetchRoleData = (pageNo, filters = filterData, size = pageSize) => {
    const selectedProfile =
      filters.userProfile?.value ||
      (typeof filters.userProfile === "string" ? filters.userProfile : "");

    const payload = {
      username: loggedInUserName,
      userProfile: selectedProfile,
      roleName: filters.roleName || "",
      status: filters.status.length > 0 ? filters.status : ["Active", "Block", "In-Active"],
      fromDate: formatDate(filters.fromDate),
      toDate: formatDate(filters.toDate),
      search: filters.search || "",
    };

    setLoading(true);

    axiosPostApi(
      // `${apiList.FETCH_ROLE_DATA}?&pageSize=${pageSize}&pageNo=${currentPage}`,
      `${apiList.FETCH_ROLE_DATA}?&pageSize=${size}&pageNo=${pageNo}`,
      payload
    )
      .then((response) => {
        if (
          response?.data?.status === true &&
          response?.data?.respCode === "00"
        ) {
          setPageDetails(response?.data?.pageDetails);
          let modifiedData = modifyStructure(response?.data?.data);
          if (selectedProfile && modifiedData) {
            modifiedData = modifiedData.filter(
              (item) =>
                (item.userProfile || "").toUpperCase() ===
                selectedProfile.toUpperCase()
            );
          }
          setRoleData(modifiedData);

          if (modifiedData?.length === 0) {
            setNoData(true);
          } else {
            setNoData(false);
          }
        } else {
          setNoData(true);
          setRoleData([]);
        }
      })
      .catch((error) => {
        CustomAlert({
          title: "Error",
          text: "An error occurred while fetching the data. Please try again later.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const modifyStructure = (response) => {
    return response?.map((item, index) => ({
      ...item,
      id: index + 1,
    }));
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const handleAuthorization = (authData) => {
    const requestBody = {
      ...authData,
      username: loggedInUserName,
      status: "1",
    };

    axiosPostApi(apiList.AUTH_ROLE_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          toast.success("User menu Authorized successfully!");
          fetchRoleData(1, filterData);
        } else {
          CustomAlert({
            title: "Failed to Authorized",
            text:
              response?.data?.message ||
              "Invalid credentials. Please try again!",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      })
      .catch((error) => {
        console.error("Error Authorized Role", error);
        toast.error("Failed to Authorized Role.");
      });
  };

  const roleHeaders = [
    "Status",
    "User Profile",
    "Role Code",
    "Role Name",
    "Created on Date-time",
  ];

  const roleHeaderToKeyMap = {
    Status: "authStatus",
    "User Profile": "userProfile",
    "Role Code": "userRole",
    "Role Name": "roleName",
    "Created on Date-time": "createdDt",
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
    setModalAction("");
  };

  const handlerRole = (data, actionType = "view") => {
    setModalAction(actionType);
    if (actionType === "add") {
      setEditData({});
      setShowModal(true);
    } else {
      let venData = roleData.find((item) => item?.id === data?.id);
      if (venData) {
        setEditData(venData);
        setShowModal(true);
      }
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <>
    <HeaderWithBreadcrumb title="Role Master" breadcrumb="Master" />
    <FilterBar
      values={filterData}
      onChange={(next) => {
        setFilterData(next);
        setCurrentPage(1);
        fetchRoleData(1, next, pageSize);
      }}
      search={{ key: "search", placeholder: "Search role name or code" }}
      selects={[
        {
          key: "userProfile",
          allLabel: "All profiles",
          chipLabel: "Profile",
          options: ROLE_PROFILE_OPTIONS,
          toValue: (stored) => stored?.value || (typeof stored === "string" ? stored : ""),
          fromOption: (option) => option || null,
        },
        { key: "status", allLabel: "All statuses", chipLabel: "Status", options: ROLE_STATUS_OPTIONS, ...asStatusList },
      ]}
      dateRange={{ fromKey: "fromDate", toKey: "toDate", label: "Created" }}
    />
    <div className="bg-[#FFFFFF] shadow-custom rounded-[14px] rounded-tl-none px-[10px]">
      {loading ? (
        <Loader />
      ) : (
        <>
          <MasterTable
            headers={roleHeaders}
            data={roleData}
            handleAction={handlerRole}
            filterFields={["userRole"]}
            entityType="Role"
            headerToKeyMap={roleHeaderToKeyMap}
            loading={loading}
            noData={noData}
            handleAuth={handleAuthorization}
            pageDetails={pageDetails}
            currentPage={currentPage}
            // pageSize={pageSizeCount}
            pageSize={pageSize}
            totalRecord={totalRecord}
            // fetchNextData={fetchRoleData}
            fetchNextData={(pageNo, size) => fetchRoleData(pageNo, filterData, size)}
            setCurrentPage={setCurrentPage}
            openModalFilter={openModalFilter}
            handleReset={handleReset}
            filterData={filterData}
            // fetchData={() => fetchRoleData(1, defaultFilterData)}
            fetchData={() => fetchRoleData(1, filterData, pageSize)}
            setPageSize={setPageSize}
            hideFilterControls
          />
          <RoleModal
            show={showModal}
            handleClose={handleCloseModal}
            editData={editData}
            action={modalAction}
            fetchRoleData={() => fetchRoleData(1, filterData, pageSize)}
          />
          {isModalOpenFilter ? (
            <RoleFilterModal
              show={isModalOpenFilter}
              handleClose={closeModalFilter}
              setRoleData={setRoleData}
              setPageDetails={setPageDetails}
              setNoData={setNoData}
              pageSize={pageSize}
              currentPage={currentPage}
              filterData={filterData}
              setFilterData={setFilterData}
              handleReset={handleReset}
              roleDataList={roleData}
            />
          ) : null}
        </>
      )}
    </div>
    </>
  );
};

export default RoleMaster;